export const getDefaultStateForCountry = (countryId: server.dto.Countries, serverReference: server.dto.ServerReference): { key: number, name: string, isCountryDefault: boolean } => {
  const country = serverReference.countries.find((c) => c.key === countryId);

  if (!country) {
    // @ts-ignore
    return { key: null, name: "", isCountryDefault: true };
  }

  // @ts-ignore
  return country.states.find((state) => state.isCountryDefault);
};

export const findCountryById = (countryId: server.dto.Countries, serverReference: server.dto.ServerReference) => {
  if (!countryId || countryId === "unknown") {
    return null;
  }

  const country = serverReference.countries.find((c) => c.key === countryId);

  if (country) {
    return country;
  }

  return null;
};

export const findStateById = (key: number, serverReference: server.dto.ServerReference) => {
  if (!key) {
    return null;
  }

  for (let i = 0; i < serverReference.countries.length; i++) {
    for (let j = 0; j < serverReference.countries[i].states.length; j++) {
      if (serverReference.countries[i].states[j].key === key) {
        return serverReference.countries[i].states[j];
      }
    }
  }

  return null;
};
